import orderPriceForecast from "@/page/order-price-forecast/routes";
import caxaOneStepOrderByCustomerRoutes from "@/page/main/caxaOneStepOrderByCustomer/routes";

import Vue from "vue";
import Router from "vue-router";
import { routeInterceptorCheckPermissionFactory } from "@oppein/op-utils";
import PageContend from "@/components/PageContend.vue";

//公共组件 头部、底部、面包屑...
const Layout = () => import("../components/layout/layout");
const LayoutContent = () => import("../components/layout/layoutContent");
//登陆
const Login = () => import("../page/login");
//主页
const home = () => import("../page/main/home");
//errorView-没有权限
const errorView = () => import("../page/errorView");
//404
const err404 = () => import("../page/404");
//测试
const test = () => import("../page/test");
//测试
const customerForm = () => import("../components/noStandardForm");
//ppt测试
const pptTest = () => import("../page/pptTest");
//水印测试
const textTest = () => import("../page/textTest");
//空白路由
const empty = () => import("../page/empty");
//登录失效页面
const loseToken = () => import("@/page/loseToken");
//订单管理
const softwareList = () => import("../page/main/index");
//订单下单属性设置检验
// const content = () => import("../page/main/chooseOrder/content");
const content = () => import("../page/main/chooseOrder/index.vue"); //任务模式
// 添加标准品
const addStandard = () => import("../page/main/addStandard/index");
// 编辑添加标准品
const editAddStandard = () =>
  import("../page/main/addStandard/addStandard.vue");
// 确认下单
const confirmOrder = () => import("../page/main/confirmOrder/index");
// 确认客户信息
const confirmCustomerInfo = () =>
  import("../page/main/confirmCustomerInfo/index");
const relevanceCustomer = () =>
  import("../page/main/confirmCustomerInfo/customer");
const historyCustomers = () =>
  import("../page/main/confirmCustomerInfo/history/index");
// 统一检查
const checkFiles = () => import("../page/main/checkFiles/index.vue");
// 模块自检功能
const checkFilesModuleSelfTest = () => import("../page/main/checkFiles/indexModuleSelfTest.vue");
// 库存检查
const inventoryCheck = () => import("../page/main/checkFiles/inventoryCheck");
// 库存检查
const materialsCalculation = () =>
  import("../page/main/checkFiles/materialsCalculation");
// 统一检查Mtds2
const checkFilesMtds2 = () => import("../page/main/checkFiles/indexMtds2");
//历史检查
const historicalCheck = () => import("../page/main/checkFiles/history/index");
//拆单详情
const SplitOrderDetails = () => import("../page/main/SplitOrderDetails/index");
//我的下单任务
const taskComponent = () => import("../page/main/tasks/index.vue");
//ppt编辑
const pptEditor = () => import("../page/main/oneKeyPpt/pptEditor");
//ppt编辑
const pptTemplateEditor = () =>
  import("../page/main/oneKeyPpt/pptTemplateEditor");
// ppt模板列表
const pptTemplateList = () => import("../page/main/oneKeyPpt/pptTemplateList");
// ppt模板选择
// const pptTemplateSelect = () => import("../page/main/oneKeyPpt/pptTemplateSelect/index");
// ppt本地插图管理
const localImageManage = () =>
  import("../page/main/oneKeyPpt/localImageManage");
// 历史 ppt
const pptHistory = () =>
  import("../page/main/oneKeyPpt/pptTemplateSelect/historyPPT");
// 创建 ppt v2.0
const pptDesign = () => import("../page/main/oneKeyPpt/pptDesign");
// 提问列表
const questionsList = () =>
  import("../page/main/questionsAnswersPlatform/managePlatform/questionsList");
// 我的提问记录
const myQuestionsList = () =>
  import(
    "../page/main/questionsAnswersPlatform/myQuestions/caxa/questionsList"
  );
// 我的提问记录
const questionsDetails = () =>
  import(
    "../page/main/questionsAnswersPlatform/managePlatform/questionsDetail"
  );
// 我的提问记录
const questionsTips = () =>
  import(
    "../page/main/questionsAnswersPlatform/myQuestions/caxa/questionsTips"
  );
// 绑定账号
const binding = () => import("../page/main/questionsAnswersPlatform/binding");
// 绑定账号列表
const bindList = () =>
  import("../page/main/questionsAnswersPlatform/binding/bindList");
// 我的客户
const myCustomer = () => import("../page/main/myCustomer");
// 方案详情
const planDetail = () => import("../page/main/myCustomer/planDetail");
// 促销算价
const chuxiaoPrice = () => import("../page/main/checkFiles/ChuxiaoPrice");

const orderFormSearch = () => import("../page/orderForm/orderFormSearch");
const orderForm = () => import("../page/orderForm");
const orderFormCheck = () => import("../page/orderForm/orderCheckResult");
const formCheckResult = () => import("../page/main/formCheckResult");
// 三步合一下单页面
const order = () => import("../page/main/order");
// caxa三步合一下单页面
const caxaOneStepOrder = () => import("../page/main/caxaOneStepOrder/index");
// caxa三步合一2下单页面
const caxaOneStepOrder2 = () => import("../page/main/caxaOneStepOrder2/index");
// const SplitTips = () => import("../page/main/tipsList/index");
// caxa三步合一外贸下单页面
const caxaOneStepProject = () =>
  import("../page/main/caxaOneStepProject/index.vue");
// caxa三步合一工程下单页面
const caxaOneStepProjectGc = () =>
  import("../page/main/caxaOneStepProjectGc/index.vue");
// caxa三步合一工程mtds本地下单页面
const caxaOneStepProjectGcMtdsGcOrder = () =>
  import("../page/main/caxaOneStepProjectGc/mtdsGcOrder/index.vue");

const mainContractNumberTag = () =>
  import("../components/developerInfo/components/mainContractNumberTag.vue");
// const SplitTips = () => import("../page/main/tipsList/index");
Vue.use(Router);
export const constantRouterMap = [
  { path: "/", redirect: "/index", hidden: true, meta: { white: true } },
  {
    path: "/index",
    name: "设计软件订单查询",
    component: softwareList,
    meta: { keepAlive: true, white: true },
  },
  // { path: '/chooseOrder/content', name: '选择下单内容', component: content,  meta: { keepAlive: true } },
  {
    path: "/placeOrderContent/:type",
    name: "选择下单内容",
    component: content,
    meta: { keepAlive: true },
  }, //新任务模式，现阶段只有工程，后期将整合零售和代传
  {
    path: "/addStandard",
    name: "添加标准品",
    component: addStandard,
    meta: { keepAlive: true },
  },
  {
    path: "/wireFrame",
    name: "线框图",
    component: editAddStandard,
    meta: { keepAlive: true },
  },
  {
    path: "/createOffer",
    name: "报价",
    component: editAddStandard,
    meta: { keepAlive: true },
  },
  {
    path: "/editAddStandard",
    name: "编辑添加标准品",
    component: editAddStandard,
    meta: { keepAlive: true },
  },
  {
    path: "/confirmOrder",
    name: "确认下单",
    component: confirmOrder,
    meta: { keepAlive: true },
  },
  {
    path: "/confirmCustomerInfo",
    name: "确认客户信息(caxa)",
    component: confirmCustomerInfo,
  },
  { path: "/check/caxa", name: "统一检查(caxa)", component: checkFiles },
  { path: "/check/software/moduleSelfTest", name: "模块自检功能", component: checkFilesModuleSelfTest },
  { path: "/check/inventory", name: "库存检查", component: inventoryCheck },
  {
    path: "/materialsCalculation",
    name: "物料清单计算",
    component: materialsCalculation,
  },
  {
    path: "/check/mtds2",
    name: "统一检查(mtds2)",
    component: checkFilesMtds2,
  },
  {
    path: "/historicalCheck/caxa",
    name: "历史检查(caxa)",
    component: historicalCheck,
  },
  {
    path: "/relevanceCustomer/:type",
    name: "我的客户",
    component: relevanceCustomer,
  },
  {
    path: "/historicalCustomers/:type",
    name: "我的历史客户",
    component: historyCustomers,
  },
  {
    path: "/taskManagement/caxa",
    name: "我的下单任务",
    component: taskComponent,
  },
  {
    path: "/SplitOrderDetails",
    name: "拆单详情",
    component: SplitOrderDetails,
  },
  {
    path: "/pptTemplateList",
    name: "ppt模板列表",
    component: pptTemplateList,
  },
  { path: "/pptTemplateSelect", name: "ppt模板选择", component: pptDesign },
  { path: "/pptHistory", name: "ppt历史", component: pptHistory },
  {
    path: "/localImageManage",
    name: "ppt本地插图管理",
    component: localImageManage,
  },
  { path: "/pptEditor", name: "ppt编辑", component: pptEditor }, //,meta:{white:true}
  {
    path: "/pptTemplateEditor",
    name: "ppt模板编辑",
    component: pptTemplateEditor,
  }, //,meta:{white:true}
  {
    path: "/manageQuestionsList",
    name: "提问列表",
    component: questionsList,
  },
  {
    path: "/myQuestionsList",
    name: "我的提问记录",
    component: myQuestionsList,
  },
  {
    path: "/manageQuestionsDetails",
    name: "后台问题详情",
    component: questionsDetails,
  },
  {
    path: "/questionsDetails",
    name: "问题详情",
    component: questionsDetails,
  },
  { path: "/questionsTips", name: "问题提示", component: questionsTips },
  { path: "/myCustomer", name: "客户", component: myCustomer },
  { path: "/myCustomer/planDetail", name: "方案详情", component: planDetail },
  { path: "/promotionPricing", name: "促销算价", component: chuxiaoPrice }, // meta: {white:true}
  { path: "/order", name: "一键下单", component: order },
  {
    path: "/caxaOneStepOrder",
    name: "一键下单(caxa)",
    component: caxaOneStepOrder,
  },
  {
    path: "/caxaOneStepOrder2",
    name: "一键下单(caxa)2",
    component: caxaOneStepOrder2,
  },
  {
    path: "/caxaOneStepProject",
    name: "一键下单(外贸)",
    component: caxaOneStepProject,
  },
  {
    path: "/caxaOneStepProjectGc",
    name: "一键下单(工程)",
    component: caxaOneStepProjectGc,
  },
  {
    path: "/caxaOneStepProjectGc/mtdsGcOrder",
    name: "工程本地建单",
    meta: { 
      name: "工程本地建单",
      componentName: "MtdsGcOrder", 
    },
    component: caxaOneStepProjectGcMtdsGcOrder,
  },
  {
    path: "/formcheck/result",
    name: "营销检查管理",
    component: formCheckResult,
    meta: { white: true },
  },

  //内部代传
  {
    path: "/resources/main",
    redirect: "/resources/main/home",
    name: "首页",
    component: Layout,
    meta: { white: true },
    icon: "zhuye",
    noDropdown: true,
    children: [
      { path: "home", name: "", component: home, meta: { white: true } },
      {
        name: "errorView",
        path: "errorView",
        component: errorView,
        meta: { white: true },
      },
    ],
  },
  {
    path: "/resources/test",
    name: "test",
    component: test,
    meta: { white: true },
  }, //测试
  {
    path: "/resources/pptTest",
    name: "pptTest",
    component: customerForm,
    meta: { white: true },
  }, //测试
  {
    path: "/resources/loseToken",
    name: "lose-token",
    component: loseToken,
    meta: { white: true },
  }, //用户过期
  {
    path: "/resources/no-permission",
    name: "no-permission",
    component: empty,
    meta: { white: true },
  }, //空白页面

  {
    path: "/binding",
    name: "绑定账号",
    component: binding,
    meta: { white: true },
  }, // 绑定账号
  {
    path: "/bindList",
    name: "绑定账号列表",
    component: bindList,
    meta: { white: true },
  }, // 绑定账号列表

  {
    path: "/orderForm",
    name: "OrderForm",
    component: orderForm,
    redirect: "/orderForm/checkResult",
    meta: {
      title: "营销检查管理",
    },
    children: [
      {
        path: "search",
        name: "OrderFormSearch",
        component: orderFormSearch,
        meta: {
          title: "订单表单查询",
        },
      },
      {
        path: "checkResult",
        name: "OrderCheckResult",
        component: orderFormCheck,
        meta: {
          title: "订单检查结果查询",
        },
      },
    ],
  },
  {
    path: "/mainContractNumberTag",
    name: "合同号取号标签",
    component: mainContractNumberTag,
    meta: { white: false },
  },
  {
    path: "/designercenter",
    name: "DesignerCenter",
    meta: {
      title: "设计者中心",
    },
    component: () => import("@/page/designCenter"),
  },
  ...orderPriceForecast,
  ...caxaOneStepOrderByCustomerRoutes,
];
// 遍历路由信息数组，检查path属性是否/开头，如果是则去掉/
function removeSlash(arr) {
  const ret = [...arr];
  ret.forEach((item) => {
    if (item.path && item.path.startsWith("/")) {
      item.path = item.path.substring(1);
    }
  });
  return ret;
}

function getRouterParams() {
  const originRoutes = constantRouterMap.concat({
    path: "*",
    name: "notFound",
    component: err404,
    meta: { white: true },
  });
  if (process.env.DEPLOY_ENV === "mtds2-child") {
    return {
      linkActiveClass: "active",
      scrollBehavior: () => ({ y: 0 }),
      routes: [
        {
          path: "/child/microapp-caxaOneClickOrder",
          alias: "/",
          component: PageContend,
          children: removeSlash(originRoutes),
        },
      ],
    };
  } else {
    return {
      mode: "history",
      linkActiveClass: "active",
      scrollBehavior: () => ({ y: 0 }),
      routes: originRoutes,
    };
  }
}
function initRouter() {
  const router = new Router(getRouterParams());
  const checkPermissionInterceptor = routeInterceptorCheckPermissionFactory({
    name: "no-permission",
  });
  router.beforeEach(checkPermissionInterceptor);
  return router;
}
export default initRouter;



// WEBPACK FOOTER //
// ./src/router/index.js